import { ReactNode, createContext, useContext } from 'react';

import { RfiDetailProps } from '../types';

export const RfiDetailContext = createContext<RfiDetailProps>({});

export interface RfiDetailProviderProps extends RfiDetailProps {
  children: ReactNode;
}

export const RfiDetailProvider = (props: RfiDetailProviderProps) => {
  const { children, ...args } = props;
  return <RfiDetailContext.Provider value={{ ...args }}>{children}</RfiDetailContext.Provider>;
};

export const useRfiDetailContext = () => useContext(RfiDetailContext);
